import styled from 'styled-components';

import {
  Block as BaseBlock,
  Footer as BaseFooter,
  Header as BaseHeader,
  Item as BaseItem,
  ModalHead as BaseModalHead,
  ScrollContainer as BaseScrollContainer,
  SpacedRow as BaseSpacedRow,
  Wrap as BaseWrap
} from './base';

export {
  Container,
  Data,
  EntryDescriptionRow,
  FeeDeliveryItem,
  Label,
  LoadingContainer,
  ModalInner,
  OrderDetailsScrollContainer,
  Row,
  StyledModal,
  TrackOrderLink,
  CateringPendingApproval,
  Col,
  ItemNameContainer,
  Items,
  MoreItems,
  NumItems,
  SubtitleContainer,
  Tile,
  FormattedDate,
  RecentOrderTitle,
  ButtonCol,
  OrderNumber,
  OrderNumberWrapper,
  OrderNumberText,
  TicketNumber
} from './base';

export const ScrollContainer = styled(BaseScrollContainer)`
  padding-top: 5.75rem;
`;

export const ModalHead = styled(BaseModalHead)`
  h2 {
    font-size: 1.5rem;
  }
`;

export const Block = styled(BaseBlock)`
  p {
    color: #595050;
  }
`;

export const Header = styled(BaseHeader)`
  p {
    font-size: 1rem;
  }
`;

export const SpacedRow = styled(BaseSpacedRow)`
  p {
    font-size: 1rem;
  }
`;

export const Footer = styled(BaseFooter)`
  p {
    color: #595050;
  }
`;

export const Item = styled(BaseItem)`
  p,
  h4 {
    font-size: 1rem;
  }
`;

export const ItemName = styled.h4`
  order: -3;
  flex: 1;
`;
export const ItemPrice = styled.p`
  order: -1;
`;

export const ItemQuantityBadge = styled.div<{ quantityText?: string }>`
  order: -2;
  margin-right: 2rem;
  &:before {
    content: ${({ quantityText = 'Qty: ' }) => quantityText};
  }
`;

export const Wrap = styled(BaseWrap)`
  ${Styles.desktop`
    margin-bottom: 3rem;
  `}
`;

export const NeedHelpButtonLoadingIndicatorWrapper = styled.div`
  padding: 0.7rem;
  border: '1px solid transparent';
`;
